'use strict';

module.exports = [require('./bignumber'), require('./boolean'), require('./chain'), require('./complex'), require('./fraction'), require('./matrix'), require('./number'), require('./numeric'), require('./resultset'), require('./string'), require('./unit')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/type/index.js
// module id = uCcQ
// module chunks = 3